import { Seguradoras } from "#/enums";

export const DESCRICAO_SEGURADORAS: { [key in Seguradoras]: string } = {
  [Seguradoras.ALIRO]: "Aliro Seguro",
  [Seguradoras.YELUM]: "Yelum",
};
